import Loading from '../../../components/Loading/Loading';
import { AssistanceStackParamList } from '../../../types/navigation';

import { LegacyAssistance } from '../../../components/Assistance/LegacyAssistance/LegacyAssistance';
import { NewAssistance } from '../../../components/Assistance/NewAssistance/NewAssistance';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/useStores';


type AssistanceProps = AssistanceStackParamList['Assistance']
const Assistance: React.FunctionComponent<AssistanceProps> = observer(props => {
  const rootStore = useStores();
  const assistanceData = rootStore?.user?.company;
  if(!assistanceData){
    return(<Loading/>);
  }
  if (!assistanceData?.hasAccessToWpoAssistance) {
    return (
      <LegacyAssistance
        {...props}
      />
    );
  }
  return (
    <NewAssistance
      {...props}
    />
  );
});


export default Assistance;

